<template>
    <v-container grid-list-md fluid>
        <v-row no-gutters class="d-flex justify-center">
            <v-col cols="12">
                <v-row no-gutters cols="12" class="my-3 justify-center">
                    <v-col cols="2" class="pr-1">
                        <v-btn-primary block @click="$router.push({ name: 'new-accounting-plan' })">
                            Ajouter
                        </v-btn-primary>
                    </v-col>
                    <v-col cols="2" class="pl-1">
                        <v-btn-primary block @click="importPlansDialog = true">
                            Importer
                        </v-btn-primary>
                    </v-col>
                    <v-col cols="8" class="pl-2">
                        <v-text-field
                            v-model="search"
                            label="Recherche"
                            append-inner-icon="$search"
                            clearable
                            @click:clear="search = ''"
                            outlined
                            hide-details
                            density="compact"
                        />
                    </v-col>
                </v-row>
            </v-col>
            <RuleTable
                :rule="'accountingPlan'"
                :items="items"
                :accountingCompanyId="accountingCompanyId"
                :patternCount="patternCount"
                :firstRequestDone="firstRequestDone"
                :pagination="pagination"
                :maxHeight="maxHeightRT"
                @to-route="routeEdition($event.id)"
                @duplicate="duplicate($event.id)"
                @delete="
                    accountingPlanToDelete = $event;
                    deleteDialog = true;
                "
            ></RuleTable>
        </v-row>
        <oss-dialog
            v-model="deleteDialog"
            title="Supprimer"
            :error="true"
            @close="accountingPlanToDelete = undefined"
            @valid="deletePattern"
            :validLoading="deleteLoading"
            width="800px"
        >
            <h4 class="text-center">
                &#xca;tes-vous sûr(e) de vouloir supprimer ce plan comptable ?
            </h4>
        </oss-dialog>
        <oss-dialog
            v-model="importPlansDialog"
            :minWidth="width"
            title="Importez votre Plan Comptable"
            :actions="importActions"
            v-if="importPlansDialog"
        >
            <AccountingPlanImport
                ref="importComponent"
                v-if="importPlansDialog"
                :documentType="'ACCOUNTING_PLAN'"
                :actions="importActions"
                @documentImported="onDocumentImported($event)"
                @width="changeWidth()"
            />
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import { User } from "../../store/store";

import { DialogAction } from "../../services/dialogAction";
import AccountingPlanImport from "../import/AccountingPlanImport.vue";
import RuleTable from "./RuleTable.vue";

import ACCOUNTABLE_ACCOUNT_TABLES from "../../graphql/accountableAccount/AccountableAccountTables.gql";
import DELETE_ACCOUNTING_PLAN from "../../graphql/accountableAccount/DeleteAccountingPlan.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        AccountingPlanImport,
        RuleTable,
    },
})
export class AccountingPlans extends Vue {
    pagination: any = {
        page: 1,
        rowsPerPage: 20,
        sortBy: "name",
    };

    firstRequestDone = false;
    patternCount = 0;

    search = "";

    importPlansDialog = false;

    importActions = {
        action: new DialogAction(),
    };

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingCompanyId() {
        return this.$store.state.user.company.id;
    }

    get isRootProfile() {
        if (this.currentUser.isRoot) {
            return true;
        }
        return false;
    }

    get maxHeightRT() {
        return "calc(100vh - 160px)";
        const innHeight = window.innerHeight;
        const vhHeight = (200 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    @Watch("search")
    onSearchModified(value) {
        this.items = [];
        this.pagination.page = 1;
        this.firstRequestDone = false;
    }

    @Apollo({
        query: ACCOUNTABLE_ACCOUNT_TABLES,
        variables() {
            return {
                first: this.pagination.rowsPerPage,
                skip: (this.pagination.page - 1) * this.pagination.rowsPerPage,
                accountingCompanyId: this.accountingCompanyId,
                search: this.search ? this.search : undefined,
            };
        },
        skip() {
            return !this.accountingCompanyId;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data) {
                    this.firstRequestDone = true;
                    this.items.push(...data.accountableAccountTables);
                    this.patternCount = data.accountableAccountTablesConnection.aggregate.count;
                } else {
                    this.pagination.page = 1;
                    this.patternCount = 0;
                }
            }
        },
    })
    items: Array<any> = [];

    routeEdition(id) {
        this.$router.push({
            name: "accounting-plan",
            params: {
                id: id,
            },
        });
    }

    duplicate(id) {
        this.$router.push({
            name: "new-from-accounting-plan",
            params: {
                idToDuplicate: id,
            },
        });
    }

    accountingPlanToDelete;
    deleteDialog = false;
    deleteLoading = false;

    async deletePattern() {
        this.deleteLoading = true;
        if (this.accountingPlanToDelete) {
            await this.$apollo.mutate({
                mutation: DELETE_ACCOUNTING_PLAN,
                variables: {
                    id: this.accountingPlanToDelete.id,
                },
            });
            this.accountingPlanToDelete = undefined;
            this.refresh();
        }
        this.deleteDialog = false;
        this.deleteLoading = false;
    }

    onDocumentImported(importedPlan) {
        this.importPlansDialog = false;
        this.$store.commit("updateImportPlanData", importedPlan);
        this.$router.push({ name: "new-accounting-plan" });
    }

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        } else {
            debugger;
        }
    }

    width = "60%";
    changeWidth() {
        //@ts-ignore
        if (this.$refs.importComponent?.step !== 0) {
            this.width = "75%";
        } else {
            this.width = "60%";
        }
    }
}

export default toNative(AccountingPlans);
</script>
